import { useCallback } from 'react'

export function useFocusCallback(onFocus, pageFieldsData) {
	const { variable, list } = pageFieldsData

	return useCallback(
		() =>
			onFocus
				? list !== undefined
					? onFocus(list, variable.name)
					: onFocus(variable.name)
				: undefined,
		[onFocus, list, variable.name]
	)
}
